// src/App.js
import React, { useEffect, useRef, useState, useCallback } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Plans from './components/Plans';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import Benefits from './components/Benefits';
import WhatsAppButton from './components/WhatsAppButton';
import BackgroundGlow from './components/BackgroundGlow';

function App() {
  const contactRef = useRef(null);
  const [contactMessage, setContactMessage] = useState('');

  const getBaseOffset = useCallback(() => {
    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 0;
    const basePadding = window.innerWidth >= 768 ? -24 : 16;
    return headerHeight + basePadding;
  }, []);

  const getSectionOffset = useCallback((sectionId) => {
    switch (sectionId) {
      case 'planes':
        return window.innerWidth >= 768 ? -24 : 0;
      case 'beneficios':
        return window.innerWidth >= 768 ? 72 : 16;
      case 'contacto':
        return window.innerWidth >= 768 ? -48 : 24;
      default:
        return 0;
    }
  }, []);

  const scrollToElement = useCallback(
    (element) => {
      if (!element) return;
      const top =
        element.getBoundingClientRect().top +
        window.pageYOffset -
        getBaseOffset() -
        getSectionOffset(element.id);

      window.scrollTo({ top, behavior: 'smooth' });
    },
    [getBaseOffset, getSectionOffset]
  );

  const scrollToContact = useCallback(() => {
    if (contactRef.current) scrollToElement(contactRef.current);
  }, [scrollToElement]);

  useEffect(() => {
    const handleAnchorClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;

      const targetId = anchor.getAttribute('href')?.substring(1);
      const target = document.getElementById(targetId);
      if (!target) return;

      e.preventDefault();
      scrollToElement(target);
    };

    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, [scrollToElement]);

  return (
    <div className="relative min-h-screen bg-slate-950 text-white overflow-hidden">
      {/* 🔥 FONDO GLOBAL */}
      <BackgroundGlow intensity="high" />

      <Header />

      <section id="home" className="relative z-10">
        <Hero
          setContactMessage={setContactMessage}
          scrollToContact={scrollToContact}
        />
      </section>

      <Plans />

      <section id="beneficios" className="relative z-10">
        <Benefits />
      </section>

      <section id="contacto" ref={contactRef} className="relative z-10">
        <ContactForm initialMessage={contactMessage} />
      </section>

      <WhatsAppButton />
      <Footer />
    </div>
  );
}

export default App;
